import { Fragment, PropsWithChildren } from 'react';
import styles from './panel-content-small.module.scss';

export interface PanelContentSmallProps {
	title: string;
	image: string;
}

export const PanelContentSmall = (props: PropsWithChildren<PanelContentSmallProps>) => {
	return (
		<Fragment>
			<img src={props.image} title={props.title} />
			<h2 className={styles.title}>{props.title}</h2>
			{props.children}
		</Fragment>
	)
}